module.exports = __webpack_public_path__ + "static/icon_loading.205dc678.png";